import * as Common from '../../common/common'
import * as Servlet from '../../common/servlet'
import axios from 'axios'
import Highcharts from 'highcharts'
import "jquery-ui/ui/widgets/draggable";
import PatternFill from 'highcharts/modules/pattern-fill';

window.jQuery = $
window.$ = $

let lsttm = null;
let zindex = 0;

/***************************************************/
/************** DOM 로드 후 초기화 함수 호출 *************/
/***************************************************/
window.addEventListener('DOMContentLoaded', () => {
	const rmststs = Servlet.lsttm()
	rmststs.then((result) => {
		document.getElementById("lsttm").value = result[0].lsttm
		lsttm = document.getElementById("lsttm").value
		document.getElementById("plsttm").innerText = Common.getDateTime2Separator(result[0].lsttm, '-');

		// 날짜 세팅
		const getHour = result[0].lsttm.substring(8, 10)
		const getMin = result[0].lsttm.substring(10, 12)

		Common.setTime2sc();
		Common.selectMakeHour('scHour', getHour)
		Common.selectMakeMin('scMin', getMin)
	}).then(() => {
		initWlData();
	})

	const zoomStep = 0.4;
	let scaleValue = 1;
	let isDragging = false;
	let startX = 0, startY = 0;
	let translateX = 0, translateY = 0;
	let svg = document.querySelector("#svgImage");
	let ph = document.querySelector(".ph");

	svg.style.transformOrigin = "center center";
	svg.style.position = "absolute";

	const isMobile = /Mobi|Android|iPhone/i.test(navigator.userAgent);

	// 공통 transform 업데이트 함수
	function updateTransform(type) {
		svg.style.transform = `translate(${translateX}px, ${translateY}px) scale(${scaleValue})`;
	}

	if (isMobile) {
		let lastTouchDistance = null;
		let isTouchDragging = false;

		// 터치 시작
		svg.addEventListener("touchstart", function(e) {
			if (e.touches.length === 1) {
				isTouchDragging = true;
				startX = e.touches[0].clientX - translateX;
				startY = e.touches[0].clientY - translateY;
			} else if (e.touches.length === 2) {
				isTouchDragging = false;
				lastTouchDistance = getDistance(e.touches[0], e.touches[1]);
			}
		});

		// 터치 중
		svg.addEventListener("touchmove", function(e) {
			e.preventDefault();

			if (e.touches.length === 1 && isTouchDragging) {
				translateX = e.touches[0].clientX - startX;
				translateY = e.touches[0].clientY - startY;
				updateTransform("touch-drag");
			} else if (e.touches.length === 2) {
				let currentDistance = getDistance(e.touches[0], e.touches[1]);

				if (lastTouchDistance) {
					let scaleDelta = (currentDistance - lastTouchDistance) * 0.005;
					scaleValue += scaleDelta;

					let maxScale = Math.min(ph.offsetWidth / svg.getBBox().width, ph.offsetHeight / svg.getBBox().height) + 2;

					if (scaleValue > maxScale) {
						scaleValue = maxScale;
					}

					if (scaleValue < 0.2) {
						scaleValue = 0.2;
					}

					updateTransform("touch-zoom");
				}

				lastTouchDistance = currentDistance;
			}
		});

		// 터치 종료
		svg.addEventListener("touchend", function() {
			isTouchDragging = false;
			lastTouchDistance = null;
		});

		// 핀치 줌
		function getDistance(t1, t2) {
			let dx = t2.clientX - t1.clientX;
			let dy = t2.clientY - t1.clientY;
			return Math.sqrt(dx * dx + dy * dy);
		}
	} else {
		// 스크롤 확대 축소
		svg.addEventListener("wheel", function(e) {
			if (isDragging) return;

			e.preventDefault();
			if (e.deltaY < 0) {
				scaleValue += zoomStep;
			} else {
				scaleValue -= zoomStep;
			}

			let maxScale = Math.min(ph.offsetWidth / svg.getBBox().width, ph.offsetHeight / svg.getBBox().height) + 1;

			if (scaleValue > maxScale) {
				scaleValue = maxScale;
			}
			if (scaleValue < 0.2) {
				scaleValue = 0.2;
			}
			
			updateTransform("wheel");
		});

		// 드래그 시작
		svg.addEventListener("mousedown", function(e) {
			isDragging = true;
			startX = e.clientX - translateX;
			startY = e.clientY - translateY;
			svg.style.cursor = "grabbing";
		});

		// 드래그 중
		document.addEventListener("mousemove", function(e) {
			if (isDragging) {
				translateX = e.clientX - startX;
				translateY = e.clientY - startY;
				updateTransform("drag");
			}
		});

		// 드래그 종료
		document.addEventListener("mouseup", function() {
			isDragging = false;
			svg.style.cursor = "grab";
		});
	}
})

const initWlData = function() {
	const circles = document.querySelectorAll('.st44, .st45, .st46, .click-target');

	circles.forEach((circle, i) => {
		circle.addEventListener("click", function(event) {
			const wlobscd = circle.getAttribute('data-obs');
			const fwobscd = wlobscd.substring(0, 5) + "5" + wlobscd.substring(6, 9);
			let sdt = makeParam().rf24h.sdt;
			let edt = makeParam().rf10m.edt;

			Common.axios.all([
				Common.axiosApi.post(`/waterlevel/Info/${wlobscd}`),
				Common.axiosApi.post(`/waterlevel/WlAndBwl/${wlobscd}/${sdt}/${edt}`), // 수위 변경 정보
				Common.axiosApi.post(`/flow/Mst/${fwobscd}/${sdt}/${edt}`),
			]).then(Common.axios.spread((...resList) => {
				let timeArr = Common.get10mTimeJsonArray(`${sdt}`, `${edt}`);

				timeArr.reverse();
				timeArr.forEach((info, i) => {
					const wab_data = resList[1].find(el => el.ymdhm === info.ymdhm);
					const fwmst_data = resList[2].find(el => el.ymdhm === info.ymdhm);

					if (wab_data != null) {
						info.wl = wab_data.wl == null ? null : Number(wab_data.wl);
					}

					if (fwmst_data != null) {
						info.fw = fwmst_data.fw == null ? null : Number(fwmst_data.fw).toFixed(2);
					}

					info.wlobscd = resList[0].wlobscd;
					info.obsnm = resList[0].obsnm;
				})

				makePopupTooltip(timeArr[0], event);
			})).catch((error) => {
				console.log(error);
			})
		});
	})
}


const makePopupTooltip = function(timeArr, event) {
	const tooltip = document.getElementById('tooltip');
	let popId = `popup-${timeArr.wlobscd}`; // ID 충돌 방지를 위해 prefix 추가

	// 이미 있는 팝업이면 제거
	const existing = document.getElementById(popId);
	if (existing) {
		existing.remove();
	}

	let wl = (timeArr.wl == null || timeArr.wl == undefined) ? "-" : Number(timeArr.wl).toFixed(2);
	let fw = (timeArr.fw == null || timeArr.fw == undefined) ? "-" : Number(timeArr.fw).toFixed(2);

	// 팝업 HTML 생성
	let tooltipHtml = "";
	tooltipHtml += "<div class='mo w popup-tooltip' id='" + popId + "' style='display:block; position:absolute; width:250px; z-index:" + zindex + "'>";
	tooltipHtml += "	<div class='t'>" + timeArr.obsnm;
	tooltipHtml += "		<span class='popCloseBtn'>";
	tooltipHtml += "			<img src='/images/main-lg-00.png' alt='close tooltip'>";
	tooltipHtml += "		</span>";
	tooltipHtml += "	</div>";
	tooltipHtml += "	<table>";
	tooltipHtml += "		<caption></caption>";
	tooltipHtml += "		<colgroup><col style='width:47%'><col style='width:53%'></colgroup>";
	tooltipHtml += "		<tr><th>" + sessionStorage.getItem("MENU.wl") + "(m)</th><td>" + wl + "</td></tr>";
	tooltipHtml += "		<tr><th>" + sessionStorage.getItem("MENU.fw") + "(m³/s)</th><td>" + fw + "</td></tr>";
	tooltipHtml += "	</table>";
	tooltipHtml += "</div>";

	tooltip.insertAdjacentHTML('beforeend', tooltipHtml);

	// 팝업 위치 지정
	const rect = event.target.getBoundingClientRect();
	const popup = document.getElementById(popId);
	popup.style.left = rect.left + window.scrollX + 'px';
	popup.style.top = (rect.top + window.scrollY - 45) + 'px';

	// 닫기 버튼 이벤트
	popup.querySelector('.popCloseBtn').addEventListener('click', () => {
		popup.remove();
	});

	// 드래그 적용
	$("#" + popId).draggable({
		containment: "window"
	}).mousedown(function() {
		zindex++;
		$(this).css("z-index", zindex);
	});
}

const initChartData = function() {
	let edt = makeParam().rf10m.edt;

	//chart1
	let obscdList = ['206016005', '206026029', '206026202', '206036003', '206036002'];
	let obsDataList = ['Majalaya', 'Sapan', 'JB.Baleendah', 'Dayeuhkolot', 'Nanjung'];
	let wlelDataList = [];
	let gdtDataList = [];
	let w1StepDataList = [];
	let w2StepDataList = [];
	let w3StepDataList = [];

	//chart2
	let obscdList2 = ['206076204', '206076206', '206076205'];
	let obsDataList2 = ['Tanjungpura', 'Cabangbungin', 'JB. Muara Gembong']
	let wlelDataList2 = [];
	let gdtDataList2 = [];
	let w1StepDataList2 = [];
	let w2StepDataList2 = [];
	let w3StepDataList2 = [];

	Common.axios.all([
		Common.axiosApi.post(`/waterlevel/Info`), // 수위 제원 -> 이력 테이블에서 가져옴
		Common.axiosApi.post(`/waterlevel/Mst/${edt}`), // 기간 수위
	]).then(Common.axios.spread((obsListRes, wlDataRes) => {
		const obsList = obsListRes;
		const wlData = wlDataRes || [];

		let matchList = obscdList.map((code, i) => {
			const obsItem = obsList.find(item => item.wlobscd === code);
			const wlItem = wlData.find(item => item.wlobscd === code);

			return {
				code: code,
				obsItem: obsItem,
				wlItem: wlItem
			}

		});

		matchList.forEach((info, i) => {
			const obsItem = info.obsItem;
			const wlItem = info.wlItem;

			let gdt = Number(obsItem?.gdt) || 0;   // null 또는 NaN이면 0
			let gdtNull = Number(obsItem?.gdt) || null;   // null 또는 NaN이면 0
			let wl = wlItem?.wl;

			let el = (wl == null) ? null : gdt + Number(wl);
			let w1 = gdt + Number(obsItem.wrnstep1);
			let w2 = gdt + Number(obsItem.wrnstep2);
			let w3 = gdt + Number(obsItem.wrnstep3);

			wlelDataList.push(el);
			w1StepDataList.push(w1);
			w2StepDataList.push(w2);
			w3StepDataList.push(w3);
			gdtDataList.push(gdtNull);
		});

		let matchList2 = obscdList2.map((code, i) => {
			const obsItem = obsList.find(item => item.wlobscd === code);
			const wlItem = wlData.find(item => item.wlobscd === code);

			return {
				code: code,
				obsItem: obsItem,
				wlItem: wlItem
			}

		});

		matchList2.forEach((info, i) => {
			const obsItem = info.obsItem;
			const wlItem = info.wlItem;

			var gdt = Number(obsItem?.gdt) || 0;   // null 또는 NaN이면 0
			var gdtNull = Number(obsItem?.gdt) || null;   // null 또는 NaN이면 0
			var wl = wlItem?.wl;

			var el = (wl == null) ? null : gdt + Number(wl);
			var w1 = gdt + Number(obsItem.wrnstep1);
			var w2 = gdt + Number(obsItem.wrnstep2);
			var w3 = gdt + Number(obsItem.wrnstep3);

			wlelDataList2.push(el);
			w1StepDataList2.push(w1);
			w2StepDataList2.push(w2);
			w3StepDataList2.push(w3);
			gdtDataList2.push(gdtNull);
		});

		elChart(obsDataList, wlelDataList, w1StepDataList, w2StepDataList, w3StepDataList, gdtDataList, 'elChart');
		elChart(obsDataList2, wlelDataList2, w1StepDataList2, w2StepDataList2, w3StepDataList2, gdtDataList2, 'elChart2');
	})).catch(() => {
		elChart(obsDataList, [], [], [], [], [], 'elChart');
	});
}

const elChart = function(obsDataList, wlElDataList, w1StepDataList, w2StepDataList, w3StepDataList, gdtDataList, elDiv) {
	const allValues = [
		...wlElDataList,
		...w1StepDataList,
		...w2StepDataList,
		...w3StepDataList,
		...gdtDataList
	];

	const validValues = allValues.filter(v => typeof v === 'number' && !isNaN(v));

	const min = Math.min(...validValues);
	const max = Math.max(...wlElDataList, ...w1StepDataList, ...w2StepDataList, ...w3StepDataList, ...gdtDataList);

	PatternFill(Highcharts);
	Highcharts.chart(elDiv, {
		chart: {
			type: "spline",
			backgroundColor: '#FFF',
			zoomType: 'xy',
			plotBorderWidth: 1,
			plotBorderColor: '#000',
			events: {
				selection: function(e) {
					e.preventDefault
				},
			},
		},
		title: {
			text: ""
		},
		credits: {
			enabled: false
		},
		xAxis: [
			{
				gridLineWidth: 1,
				gridLineColor: '#c0c0c0', // 점선 색
				gridLineDashStyle: 'ShortDot', // 점선 스타일
				lineWidth: 1,
				lineColor: '#111', // 줄 색
				type: "category",
				labels: {
					formatter: function() {
						return this.value;
					},
					style: {
						color: "#111",
					},
				},
				title: {
					text: "",
				},
				legend: {
					// 범례 사용안함
					enabled: false,
				},
				categories: obsDataList,
			},
		],
		yAxis: [
			{
				labels: {
					formatter: function() {
						return Highcharts.numberFormat(this.value, 0);
					}
				},
				title: {
					text: sessionStorage.getItem("MENU.wl") + "(El.m)",
					align: "middle",
					style: {
						color: "#111",
					},
				},
				startOnTick: false,
				endOnTick: true,
				gridLineWidth: 1,
				gridLineColor: '#c0c0c0',
				gridLineDashStyle: 'ShortDot',
				min: min,
				max: max,
				plotBands: [
					{
						from: 0,
						to: 0,
						color: "rgba(255, 128, 23, 0.2)",
					},
				],
			},
		],
		tooltip: {
			shared: true,
			crosshairs: true,
			enabled: true,
			useHTML: true,
			followPointer: true, // 툴팁이 마우스 따라다니게
			valueDecimals: 2

		},
		legend: {
			verticalAlign: 'top',
			squareSymbol: true,
			symbolRadius: 0,
			symbolWidth: 20,
			itemStyle: {
				color: 'var(--color-chart-title)',
			}
		},
		plotOptions: {
			spline: {
				lineWidth: 2,
				states: {
					hover: {
						lineWidth: 3,
					},
				},
				marker: {
					enabled: false,
				},
			},
			area: {
				threshold: null,
				states: {
					hover: {
						enabled: false
					}
				}

			}, series: {
				pointPlacement: 'on' // ✔ 카테고리의 시작점(왼쪽)에서 시작
			}
		},
		series: [
			{
				name: sessionStorage.getItem("TABLE.critical") + "(El.m)",
				color: "#d21d25",
				type: "spline",
				tooltip: {
					valueSuffix: "El.m",
				},
				yAxis: 0,
				//xAxis: 0,
				data: w3StepDataList,
				marker: {
					symbol: 'text:\u25CF'
				}
			},
			{
				name: sessionStorage.getItem("MENU.alm") + "(El.m)",
				color: "#FF8017",
				type: "spline",
				tooltip: {
					valueSuffix: "El.m",
				},
				yAxis: 0,
				//xAxis: 0,
				data: w2StepDataList,
				marker: {
					symbol: 'text:\u25B6'
				}
			},
			{
				name: sessionStorage.getItem("TABLE.alert") + "(El.m)",
				color: "#fde700",
				type: "spline",
				tooltip: {
					valueSuffix: "El.m",
				},
				yAxis: 0,
				//xAxis: 0,
				data: w1StepDataList,
				marker: {
					symbol: 'text:\u25C6'
				}
			},
			{
				name: sessionStorage.getItem("MENU.wl") + "(El.m)",
				color: "#2ea1ff",
				type: "line",
				tooltip: {
					valueSuffix: "El.m",
				},
				yAxis: 0,
				//xAxis:0,
				data: wlElDataList,
				marker: {
					symbol: 'text:\u25CF'
				}
			},
			{
				name: sessionStorage.getItem("TITLE.gdt") + "(m)",
				type: 'area',
				color: {
					pattern: {
						path: {
							d: 'M 0 0 L 5 10 M 5 0 L 10 10',
							stroke: '#888',
							strokeWidth: 1
						},
						width: 10,
						height: 10
					}
				},
				enableMouseTracking: true, // 단면도는 hover 제외 
				showInLegend: false, // 단면도는 라벨 숨김
				tooltip: {
					valueSuffix: "m",
				},
				data: gdtDataList,
				zIndex: -1,
				yAxis: 0
			}
		]
	});
}

$(document).on("click", "#tabId ul li", function() {
	$("#tabId ul li").removeClass("active");

	$(this).addClass("active");

	let tabId = $(this).attr("id");
	if (tabId == "river") {
		// 모식도 탭에 열려있는 팝업창 모두 닫기
		document.querySelectorAll(".mo.w").forEach((info, i) => {
			info.remove();
		});

		// 차트
		initChartData();

		// 모식도
		document.getElementById("p1").style.display = "none";

		// 상류
		document.getElementById("cData").style.display = "block";
	} else {
		// 모식도
		document.getElementById("p1").style.display = "block";

		// 상류
		document.getElementById("cData").style.display = "none";
	}
})

const makeParam = function() {
	const value = document.getElementById("scDate").value + document.getElementById("scHour").value + document.getElementById("scMin").value;
	const ymdhm = value.replaceAll("-", "");
	const year = ymdhm.substring(0, 4);
	const month = ymdhm.substring(4, 6);
	const day = ymdhm.substring(6, 8);
	const hour = ymdhm.substring(8, 10);
	const minute = ymdhm.substring(10, 12);

	let date = new Date(year, month - 1, day, hour, minute);
	date.setMinutes(date.getMinutes() - 10); // 10분전 시간 생성

	let newYear = date.getFullYear();
	let newMonth = ("0" + (date.getMonth() + 1)).slice(-2);
	let newDay = ("0" + date.getDate()).slice(-2);
	let newHour = ("0" + date.getHours()).slice(-2);
	let newMinute = ("0" + date.getMinutes()).slice(-2);

	const rf10m = { sdt: `${newYear}` + `${newMonth}` + `${newDay}` + `${newHour}` + `${newMinute}`, edt: ymdhm };

	date = new Date(year, month - 1, day, hour, minute);
	date.setHours(date.getHours() - 1); // 1시간전 시간 생성

	newYear = date.getFullYear();
	newMonth = ("0" + (date.getMonth() + 1)).slice(-2);
	newDay = ("0" + date.getDate()).slice(-2);
	newHour = ("0" + date.getHours()).slice(-2);
	newMinute = ("0" + date.getMinutes()).slice(-2);

	const rf1h = { sdt: `${newYear}` + `${newMonth}` + `${newDay}` + `${newHour}` + `${newMinute}`, edt: ymdhm };

	date = new Date(year, month - 1, day, hour, minute);
	date.setHours(date.getHours() - 12); // 12시간전 시간 생성

	newYear = date.getFullYear();
	newMonth = ("0" + (date.getMonth() + 1)).slice(-2);
	newDay = ("0" + date.getDate()).slice(-2);
	newHour = ("0" + date.getHours()).slice(-2);
	newMinute = ("0" + date.getMinutes()).slice(-2);

	const rf12h = { sdt: `${newYear}` + `${newMonth}` + `${newDay}` + `${newHour}` + `${newMinute}`, edt: ymdhm };

	date = new Date(year, month - 1, day, hour, minute);
	date.setHours(date.getHours() - 24); // 24시간전 시간 생성

	newYear = date.getFullYear();
	newMonth = ("0" + (date.getMonth() + 1)).slice(-2);
	newDay = ("0" + date.getDate()).slice(-2);
	newHour = ("0" + date.getHours()).slice(-2);
	newMinute = ("0" + date.getMinutes()).slice(-2);

	const rf24h = { sdt: `${newYear}` + `${newMonth}` + `${newDay}` + `${newHour}` + `${newMinute}`, edt: ymdhm };

	return { rf10m: rf10m, rf1h: rf1h, rf12h: rf12h, rf24h: rf24h }
}